module.exports = __webpack_public_path__ + "img/live_head.c67a12a9.png";